// A PAYOUT ADDRESS'S STAGE, SAID (db/0098; the operator, 24–26 Oct 2026): proposed → the OWNER's Approve payout address
// in the Books → Approved (only the 10 USDT test can be paid; it counts toward the payout) → Test sent → his Received
// press → Whitelisted. The stage is the server's word, grouped by lib/custody-screen.ts whitelistGroup — reused, never
// re-derived; a stage the read did not carry is "Stage not read" and nothing is offered (Screens' round on db/0098, #3).
import type { WhitelistEntry } from '../../../lib/api';
import { whitelistGroup, landedAtOf, type WhitelistGroup } from '../../../lib/custody-screen';
import { walletState } from '../../../lib/walletStates';
import { Pill } from '../../kit';
import type { PillTone } from '../../Pill';

/** The order the list draws them in: what needs him first, then what is payable, then what is not. */
export const STAGE_ORDER: readonly WhitelistGroup[] = ['unknown', 'test_sent', 'approved', 'awaiting', 'payable', 'unavailable'];

export function stagePill(e: WhitelistEntry): { word: string; tone: PillTone } {
  const g = whitelistGroup(e);
  if (g === 'unavailable') { const s = walletState(e.status); return { word: s.word, tone: s.tone === 'good' ? 'neutral' : s.tone }; }
  if (g === 'payable') return { word: 'Whitelisted', tone: 'good' };
  if (g === 'test_sent') return { word: landedAtOf(e) ? 'Test landed' : 'Test sent', tone: 'warn' };
  if (g === 'approved') return { word: 'Approved', tone: 'neutral' };
  if (g === 'awaiting') return { word: 'Awaiting owner', tone: 'warn' };
  return { word: 'Stage not read', tone: 'bad' };
}

export function StagePill({ e }: { e: WhitelistEntry }) {
  const p = stagePill(e);
  return <Pill tone={p.tone}>{p.word}</Pill>;
}

/** Astra's "Eligibility" column: what comes next for this address, in ≤ 4 words. */
export function nextStep(e: WhitelistEntry, testUsdt: string): string {
  const g = whitelistGroup(e);
  if (g === 'payable') return 'Payable';
  if (g === 'approved') return `Send ${testUsdt} USDT test`;
  if (g === 'test_sent') return landedAtOf(e) ? 'Press Received' : 'Test on its way';
  if (g === 'awaiting') return 'Owner approves';
  if (g === 'unavailable') return 'Not payable';
  return 'Nothing payable';
}

/** The address on a payout surface: its HEAD only — the ending is what he types to sign (review pack §7; audit of
 *  21 Oct, E3), so it is shown nowhere here. */
export const payoutHead = (address: string): string => (address.length > 12 ? `${address.slice(0, 12)}…` : address);

/** The network word beside an address — TRC20, the glossary's word (TERMINOLOGY), never "TRON". */
export const networkWord = (chain: string | null | undefined): string => (!chain || /^TRC|^TRX|^TRON/.test(chain) ? 'TRC20' : chain);
